module.exports = /* @ngInject */
(
    AnalyticsService
) => {
    return {
        link: ($scope, $element, $attrs) => {
            $element.bind('click', () => {
                let url;

                if ($element.context.baseURI && $element.context.baseURI !== '#') {
                    url = $element.context.baseURI;
                }

                if ($attrs.gaAction) {
                    AnalyticsService.setGaLinkTrack($attrs.gaAction, $attrs.gaLabel);
                }
            });
        },
        restrict: 'A',
        scope: {}
    };
};
